// extracted by mini-css-extract-plugin
module.exports = {"loading":"DownloadPayReports__loading--28ib8","button":"DownloadPayReports__button--1PIxw"};